import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { FoldableListChatSkeleton } from '@/components/modules/Chat/FoldableListChat';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { Card } from '@/components/ui/Surface/Card';
/**
 * コンサルタント：案件詳細条件相談コンテンツ部分のスケルトン
 * @param props
 * @constructor
 */
export const RfpProfessionalNegotiateSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsxs(Card, Object.assign({ className: clsx(className, 'w-full', 'py-32 px-16 md:px-28'), isRounded: true, isShadow: true }, { children: [_jsx(Skeleton, { className: 'w-full h-[49px] mb-28' }), [...Array(3)].map((_, i) => (_jsxs("div", Object.assign({ className: clsx('w-full', 'flex flex-col sm:flex-col md:flex-row', 'gap-y-16 gap-x-28 sm:gap-x-12', 'pb-28 mb-16 last:mb-0 last:pb-0', 'border-b border-t-0 border-x-0 border-solid border-b-light last:border-b-0') }, { children: [_jsx("div", Object.assign({ className: clsx('w-full md:w-[210px]', 'flex flex-col flex-shrink-0', 'mt-0 md:mt-8') }, { children: _jsx(Skeleton, { className: 'w-[40%] md:w-full h-[22px]' }) })), _jsx(FoldableListChatSkeleton, { className: 'w-full' })] }), `Skeleton_${i + 1}`)))] })));
};
